var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import gql from "graphql-tag";
import { Query } from "@irati/utils/services/apollo";
var query = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query HomePageRewardsLanes {\n    homePageRewardsLanes {\n      type\n      rewards {\n        uuid\n        urlSlug\n        header\n        cardImage\n        thumbnailImage\n      }\n      tags {\n        uuid\n        name\n      }\n    }\n  }\n"], ["\n  query HomePageRewardsLanes {\n    homePageRewardsLanes {\n      type\n      rewards {\n        uuid\n        urlSlug\n        header\n        cardImage\n        thumbnailImage\n      }\n      tags {\n        uuid\n        name\n      }\n    }\n  }\n"])));
var HomePageRewardsLanesQueryComponent = /** @class */ (function (_super) {
    __extends(HomePageRewardsLanesQueryComponent, _super);
    function HomePageRewardsLanesQueryComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HomePageRewardsLanesQueryComponent.prototype.render = function () {
        return React.createElement(Query, __assign({}, this.props));
    };
    HomePageRewardsLanesQueryComponent.defaultProps = {
        query: query
    };
    return HomePageRewardsLanesQueryComponent;
}(PureComponent));
export default HomePageRewardsLanesQueryComponent;
var templateObject_1;
